/// <amd-module name="Artifacts/Npm/NpmProtocol" />

import {
  createBadgeCommand,
  createDeleteCommand,
  createDeprecateCommand,
  createDownloadCommand,
  createGetLinkCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
} from "Artifacts/Npm/commands";
import { createUpstreamOverrideCommand } from "Artifacts/Npm/commands/UpstreamOverride";
import { logoContributionId } from "Artifacts/Npm/components/Logo";
import { NpmPackageAttributes } from "Artifacts/Npm/components/NpmPackageAttributes";
import { NpmPackageOverview } from "Artifacts/Npm/components/NpmPackageOverview";
import { NpmProtocolModule } from "Artifacts/Npm/redux";
import { INpmDataService } from "Artifacts/Npm/services/NpmDataService";
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { UpstreamVersionVisibility } from "Artifacts/Root/types/PackagingShared";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class NpmProtocol implements IProtocol {
  public readonly id = Protocol.Npm;
  public readonly name = "npm";
  public readonly statusUrl = "https://status.npmjs.org/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createDownloadCommand(pageContext, versions, feed),
      createPromoteCommand(pageContext, versions),
      createDeprecateCommand(pageContext, versions),
      createDeleteCommand(pageContext, versions, feed),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createBadgeCommand(pageContext, versions, feed),
      createUpstreamOverrideCommand(pageContext),
      createGetLinkCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];

    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return NpmPackageOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return NpmPackageAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return NpmProtocolModule;
  }

  public async getUpstreamOverrideStatus(
    pageContext: IVssPageContext,
    packageName: string,
    feed?: IFeed,
  ): Promise<boolean> {
    if (!feed) {
      return false;
    }
    const dataService = pageContext.getService<INpmDataService>("INpmDataService");
    const overrideBehavior = await dataService.getUpstreamingBehavior(
      feed?.id,
      packageName,
      feed?.project?.id,
    );
    return (
      overrideBehavior?.versionsFromExternalUpstreams ===
      UpstreamVersionVisibility.AllowExternalVersions
    );
  }

  public getUpstreamingProperties(_pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: true,
      isCollectionUpstreamsSupported: true,
      isAadUpstreamsSupported: true,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }
}

ProtocolService.registerProtocol(new NpmProtocol());
